const WILDCARD_SYMBOL = '*';
const WILDCARD_PATH_CAPTURING_GROUP = '(.+)';

/*
    Gets the wildcard path given a request path (for a
    path like /foo/* and a request path like /foo/bar/baz
    returns bar/baz). If the request path doesn't match
    the redirect path (/foo/* -> /other/path) returns an
    empty string
 */
const getWildcardPath = (redirectUrl, requestPath) => {
    const wildcardRegex = new RegExp(
        redirectUrl.replace(WILDCARD_SYMBOL, WILDCARD_PATH_CAPTURING_GROUP),
    );
    const matches = requestPath.match(wildcardRegex);

    return matches ? matches[1] : '';
};

const getFullRedirect = (redirectUrl, wildcardPath) => {
    return redirectUrl.replace(WILDCARD_SYMBOL, wildcardPath);
};

const getRedirectBySpecificity = (redirects) => {
    if (!redirects.length) {
        return false;
    }

    // sorted from lower to bigger specificity
    return redirects.sort((a, b) => a.specificity - b.specificity).slice(-1)[0]
        .to;
};

const getRedirect = (homeRoute, requestUrl, redirects) => {
    if (!redirects) {
        return false;
    }

    const matchingRedirects = redirects
        .map(({from, to}) => ({
            from: `${homeRoute}${from}`,
            to: to.toLowerCase().startsWith('http') ? to : `${homeRoute}${to}`,
            specificity: from.length,
        }))
        .filter((redirect) => {
            const {from, to} = redirect;

            // TODO implement as validation in https://github.homeawaycorp.com/cms/contentful-extensions/tree/master/extensions/redirects
            if (from === to) return false;

            const wildcardPath = getWildcardPath(from, requestUrl);
            redirect.from = getFullRedirect(from, wildcardPath);
            redirect.to = getFullRedirect(to, wildcardPath);

            // FIXME validate eslint change (\/ -> /)
            return new RegExp(`^${requestUrl}/?$`).test(redirect.from);
        });

    return getRedirectBySpecificity(matchingRedirects);
};

module.exports = {
    getRedirect,
};
